import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './PasswordStrengthChecker.css'
import { analyzePassword } from './utils/passwordStrength'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const SCORE_COLORS = [
  'var(--danger)',
  '#f59e8a',
  'var(--warning)',
  '#d9e068',
  '#8ee6a8',
  'var(--success)',
]

const PasswordStrengthChecker = () => {
  useDocumentMeta({
    title: 'Verificador de Força de Senha | jarder.dev',
    description:
      'Avalie a força de uma senha e receba dicas pra deixá-la mais ' +
      'segura. Processado localmente, nada é enviado a nenhum servidor.',
  })

  const [password, setPassword] = useState('')
  const [visible, setVisible] = useState(false)

  const analysis = useMemo(() => analyzePassword(password), [password])

  const handleBlur = () => {
    if (analysis) trackEvent('tool_generate', { tool: 'password_strength' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Verificador de Força de Senha</h1>
      <p className="tool-disclaimer">
        Tudo processado localmente no seu navegador, sua senha nunca é
        enviada para nenhum servidor.
      </p>

      <div className="tool-field">
        <label htmlFor="password">Senha</label>
        <div className="password-strength-input-row">
          <input
            id="password"
            type={visible ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onBlur={handleBlur}
          />
          <button
            type="button"
            className="tool-button tool-button-secondary"
            onClick={() => setVisible((v) => !v)}
          >
            {visible ? 'Ocultar' : 'Mostrar'}
          </button>
        </div>
      </div>

      {analysis && (
        <>
          <div className="password-strength-bar">
            {[0, 1, 2, 3, 4].map((i) => (
              <span
                key={i}
                className="password-strength-segment"
                style={{ background: i <= analysis.score ? SCORE_COLORS[analysis.score] : 'var(--border)' }}
              />
            ))}
          </div>
          <p className="tool-result-value" style={{ textTransform: 'capitalize' }}>
            {analysis.level}
          </p>
          <p className="tool-import-hint">Entropia estimada: {analysis.entropy.toFixed(1)} bits</p>

          {analysis.issues.length > 0 && (
            <ul className="tool-list">
              {analysis.issues.map((issue) => (
                <li key={issue}>{issue}</li>
              ))}
            </ul>
          )}
        </>
      )}

      <div className="tool-info-section">
        <h2>O que é entropia de senha</h2>
        <p>
          Entropia mede, em bits, quantas tentativas em média um ataque
          de força bruta precisaria para descobrir a senha  quanto
          maior, mais segura. Ela cresce com o comprimento e a variedade
          de caracteres, mas cai bastante se a senha usa padrões comuns
          (sequências de teclado, palavras do dicionário, datas). Os
          problemas listados acima apontam exatamente esse tipo de
          padrão previsível que um atacante testaria primeiro.
        </p>
      </div>
    </div>
  )
}

export default PasswordStrengthChecker
